export default "__VITE_ASSET__ChSGhx8C__"